export default [
  {
    path: "/guide/partners",
    name: "guide-partners",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Контрагенты",
      permissions: ["counterparty:index"],
    },
  },
];
